import { render, staticRenderFns } from "./ForumItemMyForum.vue?vue&type=template&id=6cb9d263&scoped=true"
import script from "./ForumItemMyForum.vue?vue&type=script&lang=js"
export * from "./ForumItemMyForum.vue?vue&type=script&lang=js"
import style0 from "./ForumItemMyForum.vue?vue&type=style&index=0&id=6cb9d263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb9d263",
  null
  
)

export default component.exports